import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import FilterByForm from '../../../../components/PageHelpers/FilterByForm'
import SortBy from '../../../../components/PageHelpers/Sort'
import ActiveFiltersWithKey from '../../../../components/PageHelpers/ActiveFiltersWithKey'
import SearchBar from '../../../../components/PageHelpers/SearchBarV2'

import IconBtn from '../../../../components/Buttons/IconBtnV2'
import UseTranslation from '../../../../hooks/UseTranslation'
import FilterAltOutlinedIcon from '../../../../images/filter.svg'
import { selectNotification } from '../../../../redux/features/notifications/notificationCenter/notificationCenterSlice'
import {
  getNotificationsListWithQueries,
  filterNotificationsCenterList,
} from '../../../../redux/features/notifications/notificationCenter/notificationCenterThunk'
import OfoqDateRingPicker from '../../../../components/Forms/OfoqDateRingePicker'
import OfoqMultiAutoComplete from '../../../../components/Forms/OfoqMultiAutoComplete'

const Desktop = ({
  openModal, setOpenModal, headers, setHeaders, date, setDate,
}) => {
  const notificationStore = useSelector(selectNotification)
  const { t } = UseTranslation()
  const isFilteredArraysNotEmpty = Object.values(notificationStore?.activeFilters).some(
    (singleFilter) => singleFilter?.length,
  )
  return (
    <Box>
      <Box sx={styles.root}>

        <SearchBar
          store={notificationStore}
          actionToDispatch={getNotificationsListWithQueries}
          searchPlaceholder={t?.['Search by Details']}
          sendQueryAsObject
          actionProps={{ pageNumber: 0 }}
          customStyles={styles.SearchBar}
        />
        <Box sx={styles.summariesContainer}>
          <SortBy
            store={notificationStore}
            actionToDispatch={getNotificationsListWithQueries}
            customStyles={styles.sortBy}
            sendQueryAsObject
            actionProps={{ pageNumber: 0 }}
          />
          <IconBtn
            icon={openModal ? <CloseIcon /> : <img src={FilterAltOutlinedIcon} alt="filter icon" />}
            onClick={() => setOpenModal(!openModal)}
            customStyle={styles.filterButton}
          />
        </Box>
      </Box>

      <FilterByForm formStatus={openModal} customStyles={styles.filterForm}>
        <OfoqDateRingPicker
          name={t?.Date}
          customPlaceHolder={t?.['Select Date/period']}
          refState={setDate}
          defaultOption={date}
          customStyle={styles.firstFilter}
        />
        <OfoqMultiAutoComplete
          name={t?.Header}
          store={notificationStore?.filterList?.headers}
          defaultOption={headers}
          refState={setHeaders}
          customStyle={styles.firstFilter}
        />
      </FilterByForm>
      {isFilteredArraysNotEmpty && (
      <ActiveFiltersWithKey
        store={notificationStore}
        actionToDispatch={filterNotificationsCenterList}
        customStyles={styles.activeFilter}
      />
      )}
    </Box>
  )
}

const styles = {
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '20px',
  },
  SearchBar: {
    marginBottom: '0px !important',
  },
  filterForm: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '96%',
    padding: {
      xs: '20px 20px 0px', sm: '20px 36px 0px', md: '20px 20px 0px', lg: '20px 40px 0px',
    },
    alignItems: 'flex-start',
    marginTop: { xs: '0px', sm: '10px !important' },
  },
  firstFilter: {
    marginInlineEnd: '30px',
  },
  activeFilter: {
    flexWrap: 'wrap',
  },
  filterButton: {
    height: '40px',
    width: '40px',
    borderRadius: '12px',
    border: '1px solid #e2e8ee',
    backgroundColor: 'white',
    color: 'text.hint',
    overflow: 'hidden',
  },
  sortBy: {
    margin: { xs: '0 15px 15px', sm: '0 15px' },
  },
  summariesContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    margin: { xs: '10px 0px ', sm: '25px 0px' },
  },
}
export default Desktop
